<script setup lang="ts">
  import type { SeparatorProps } from "reka-ui";
  import type { HTMLAttributes } from "vue";
  import { reactiveOmit } from "@vueuse/core";
  import { Separator } from "reka-ui";
  import { cn } from "@/lib/utils";

  const props = withDefaults(defineProps<SeparatorProps & { class?: HTMLAttributes["class"] }>(), {
    orientation: "horizontal",
    decorative: true,
    class: "",
  });

  const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <Separator
    data-slot="separator-root"
    v-bind="delegatedProps"
    :class="
      cn(
        'bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        props.class,
      )
    " />
</template>
